<script setup lang="ts"></script>
<template>
  <p class="text-lg text-[18px] text-[#7E8597]">
    <slot></slot>
  </p>
</template>
